export const Work = [
    {
        id:1,
        name:"Financial Freedom Coach",
        description:"Simple design built on React JS.",
        tags:["react","styledComponents","css"],

        demo:"https://thefinanciallyfreeme.netlify.app/",
        github:"https://github.com/Aksaka7/ilk-web-sitem"
    },
    {
        id:2,
        name:"Foodtrack - Restaurant Management System",
        description:"Restaurant reservation and food delivery system built with Next.js.",
        tags:["nextjs","react","restaurant","booking"],

        demo:"https://foodtra.netlify.app/",
        github:"https://github.com/Aksaka7/food-market"
    },
    {
        id:3,
        name:"FoodTrack Şipşak",
        description:"Full-stack food delivery platform with real-time order management and Stripe payments.",
        tags:["nextjs","nodejs","mongodb","stripe"],

        demo:"https://foodtrack-frontend.vercel.app/",
        github:"https://github.com/Aksaka7/MehmetTruckBack-end"
    },


] 